// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import chat from '@src/views/apps/chat/store/reducer'
import todo from '@src/views/apps/todo/store/reducer'
import users from '@src/views/apps/user/store/reducer'
import email from '@src/views/apps/email/store/reducer'
import invoice from '@src/views/apps/invoice/store/reducer'
import calendar from '@src/views/apps/calendar/store/reducer'
import ecommerce from '@src/views/apps/ecommerce/store/reducer'
import dataTables from '@src/views/tables/data-tables/store/reducer'
import medicalRecords from '@src/store/medical-records/reducer'
import units from '@src/store/units/reducer'
import doctors from '@src/store/doctors/reducer'
import patients from '@src/store/patients/reducer'
import areas from '@src/store/areas/reducer'
import authentication from '@src/store/authentication/reducer'
import facilities from '@src/store/facilities/reducer'
import files from '@src/store/files/reducer'
import members from '@src/store/members/reducer'
import treatments from '@src/store/treatments/reducer'
import medicines from '@src/store/medicines/reducer'
import facilityRoles from '@src/store/facilityRoles/reducer'
import laboratoriumParameters from '@src/store/laboratoriumParameters/reducer'
import formSchemas from '@src/store/formSchemas/reducer'
import formResponses from '@src/store/formResponses/reducer'
import facilityShifts from '@src/store/facilityShifts/reducer'
import facilityShiftUsers from '@src/store/facilityShiftUsers/reducer'
import rolesNotCheckedIn from '@src/store/rolesNotCheckedIn/reducer'
import unidReducer from '@src/store/unid/reducer'
import eklaims from '@src/store/e-klaims/reducer'
import simpleMedicalRecords from '@src/store/simpleMedicalRecords/reducer'
// import { unidReducer } from '@src/store/unid'

// Import medicine reducers
import {
  medicineReducer,
  medicineTypeReducer,
  drugClassificationReducer,
  dosageFormReducer
} from '@src/store/medicine/reducer'

const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  medicalRecords,  
  units,
  doctors,
  patients,
  areas,
  authentication,
  facilities,
  files,
  members,
  // Medicine related reducers
  medicine: medicineReducer,
  medicineType: medicineTypeReducer,
  drugClassification: drugClassificationReducer,
  dosageForm: dosageFormReducer,
  treatments,
  facilityRoles,
  laboratoriumParameters,
  formSchemas,
  formResponses,
  facilityShifts,
  facilityShiftUsers,
  rolesNotCheckedIn,
  medicines,
  unid: unidReducer,
  eklaims,
  simpleMedicalRecords
})

export default rootReducer
